{
  "background.pilot": "Military pilot",
  "background.naval_officer": "Naval officer",
  "background.marine_biologist": "Marine biology",
  "background.pilot.blurb": "Two hundred flight hours over this water. On one of them, only one aircraft came back.",
  "background.naval_officer.blurb": "Fourteen years at sea, latterly as officer of the watch. You handed over your command. You did not lose it.",
  "background.marine_biologist.blurb": "You know this sea from data series and from second hand. Both of them brought you here.",
  "background.pilot.effect": "Your estimate is markedly sharper for aircraft incidents.",
  "background.naval_officer.effect": "You work heavy seas — the hull suffers noticeably less.",
  "background.marine_biologist.effect": "You read the surroundings: cold trails yield one clue more.",
  "background.lost.wingman": "your wingman",
  "background.lost.crew": "your bosun",
  "background.lost.parents": "your mother",
  "character.title": "Who are you?",
  "character.name": "Name",
  "character.name.reroll": "Another name",
  "character.background": "Background",
  "character.lost": "Lost: {name} — {relation}",
  "character.begin": "Begin",
  "character.randomise": "Roll again",
  "menu.new": "New game",
  "menu.continue": "Continue",
  "menu.seed": "Seed",
  "menu.seed.random": "Roll again",
  "menu.language": "Language",
  "menu.subtitle": "One case. A different answer every time.",
  "finale.crew.doubt": "{name} objects: 'That doesn't hold. Not with what we saw.'",
  "finale.crew.agree": "{name} nods slowly. 'That would explain all of it.'",
  "finale.tally": "Tally: {rescued} saved, {lost} not.",
  "finale.personal.found": "And {name}? That is settled now too. It does not help the way you hoped.",
  "finale.personal.open": "None of the findings say anything about {name}. Some questions stay open.",
  "finale.close": "Close the report",
  "clue.visitors.personal_trace": "The list of names includes {name}. The date beside it lies in the future.",
  "clue.leviathan.personal_trace": "An identity tag is recovered from the stomach contents of a stranded carcass. It belongs to {name}.",
  "clue.meridian.personal_trace": "{name} appears in the paperwork — not as missing, but as a line item. Settled and closed.",
  "clue.descendants.personal_trace": "The metal plate bears {name}, with a date of death that has not happened yet.",
  "clue.rift.personal_trace": "The voice on the radio tape is {name}. The recording is from this morning.",
  "crew.first_officer": "First Officer Halloran",
  "clue.cartographers.personal_trace": "Fourth in the row of outlines stands one whose measurements fit {name}. It is undamaged. It is simply no longer where it belongs.",
  "clue.wreckers.personal_trace": "In a shipping company's papers stands {name}. Signed on three months after the disappearance, to a ship that does not exist under that name.",
  "clue.echo.personal_trace": "A radio message, recorded three weeks ago, in which {name} passes a position. It was recorded six days after the disappearance."
}
